import $ from 'jquery';
import { CARD_VALIDATE_API } from 'constants/AppConstants';

const ERROR_FLAG = 'Error';
// #genai - returns ArrayBuffer | null for consistent typing
const stringToArrayBuffer = (str) => {
  if (!str) {
    return null;
  }
  const buffer = new ArrayBuffer(str.length);
  const bufferArray = new Uint8Array(buffer);
  for (let i = 0, strLen = str.length; i < strLen; i += 1) {
    bufferArray[i] = str.charCodeAt(i);
  }
  return buffer;
};

const arrayBufferToString = (buffer) => {
  const byteArray = new Uint8Array(buffer);
  let byteString = '';
  for (let i = 0; i < byteArray.byteLength; i += 1) {
    byteString += String.fromCodePoint(byteArray[i]);
  }
  return byteString;
};

const getEquivalentCybersourceCardType = (cardType) => {
  switch (String(cardType)) {
    case '1':
      return '003';
    case '2':
      return '001';
    case '3':
      return '002';
    case '4':
      return '004';
    default:
      return '003';
  }
};

const jwkToPublicKey = (cyberSourceApiKeysJwk) => window.crypto.subtle.importKey(
  'jwk',
  cyberSourceApiKeysJwk,
  {
    name: 'RSA-OAEP',
    hash: { name: 'SHA-256' },
  },
  false,
  ['encrypt'],
)
  .then((publicKey) => publicKey)
  .catch(() => ERROR_FLAG); // #genai

const encryptCardNumber = async (cardNumber, cyberSourceApiKeysJwk) => {
  const dataToEncrypt = stringToArrayBuffer(cardNumber);
  if (!dataToEncrypt) { // #genai - handle null from stringToArrayBuffer
    return ERROR_FLAG;
  }
  const publicKey = await jwkToPublicKey(cyberSourceApiKeysJwk);

  if (publicKey !== ERROR_FLAG) { // #genai
    return window.crypto.subtle.encrypt({ name: 'RSA-OAEP', hash: { name: 'SHA-256' } }, publicKey, dataToEncrypt)
      .then((encryptData) => window.btoa(arrayBufferToString(encryptData)))
      .catch(() => ERROR_FLAG); // #genai
  }
  return ERROR_FLAG; // #genai
};

function fetchToken(requestBody) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: CARD_VALIDATE_API,
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      data: JSON.stringify(requestBody),
      success(data) {
        resolve(data);
      },
      error(err) {
        reject(err);
      },
    });
  });
}

export default async (cardNumber, cardType, cybersourceKeys, expirationMonth, expirationYear) => {
  try {
    const mappedCardType = getEquivalentCybersourceCardType(cardType);
    const encryptedCardNumber = await encryptCardNumber(cardNumber, cybersourceKeys.jwk);

    if (encryptedCardNumber === ERROR_FLAG) { // #genai
      return { ok: false, json: { errorDescription: 'Internal Server Error' } };
    }

    const requestBody = {
      keyId: cybersourceKeys.keyId,
      cardInfo: {
        cardNumber: encryptedCardNumber,
        cardType: mappedCardType,
        cardExpirationMonth: (expirationMonth < 10 ? '0' : '') + String(expirationMonth),
        cardExpirationYear: String(expirationYear),
      },
    };

    const response = await fetchToken(requestBody);
    return { ok: true, json: response };
  } catch (error) {
    const {
      responseJSON: {
        responseStatus: { message },
      },
    } = error;
    return { ok: false, json: { error: message } };
  }
};
